import { ICON__ban_solid } from '@/assets/icons_fa';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_GRAPH__handle_icon_wanted_to_be_filled({ field }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);
  /*
   *
   */

  function get_is_want_to_be_filled() {
    if (!generation_current.tool.graph.nodes_map.has(field.meta.node_id)) return false;

    let node = generation_current.tool.graph.node__get(field.meta.node_id);

    if (!node.fields_ids__get_wanted_to_be_filled().includes(field.meta.field_id)) return false;

    return true;
  }

  /*
   *
   */

  if (field.meta.data__is_linked) return null;
  if (!get_is_want_to_be_filled()) return null;

  return (
    <div className="absolute top-1/2 left-0 -translate-x-[225%] -translate-y-1/2 flex items-center">
      <ICON__ban_solid className="!size-3 text-orange-500" />
    </div>
  );
}
